import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import iconG from "../../assets/Login/Icon-Google.svg";
import eyeIcon from "../../assets/Profile/edit_icon.svg";
import { BannerLogo } from "../../components/BannerLogo";
import { CustomInput } from "../../components/CustomInput";
import { useAuth } from "../../context/AuthContext";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Miniloader } from "../../components/Miniloader";

function Login() {
  const { signIn } = useAuth(); // Obtén la función de registro desde el contexto
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await signIn(data);
      Swal.fire({
        icon: "success",
        title: "Bienvenido",
        text: "Has iniciado sesión correctamente",
        timer: 2000,
        showConfirmButton: false,
        enableEscapeKey: false,
      }).then(() => {
        setLoading(false);
        setTimeout(() => {
          window.location.href = "/profile";
        }, 500);
      });
    } catch (error) {
      setLoading(false);
      // Mostramos el mensaje real que envía el servidor (cuenta inactiva,
      // contraseña incorrecta, correo no registrado). Si no hay mensaje
      // disponible, usamos un texto genérico como respaldo.
      const serverMessage =
        error?.response?.data?.message || "Usuario o contraseña incorrectos";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: serverMessage,
      });
    }
  };

  const handleRegisterClick = () => {
    navigate("/register");
  };

  // const handleLoginClick = () => {
  //     navigate('/profile');
  // };

  return (
    <div className="grid grid-cols-2 w-screen h-screen bg-[#EAEAEA] ">
      <BannerLogo />
      <div className="flex w-full h-full justify-center items-center">
        <div className="flex flex-col h-full w-[50%] justify-center items-center gap-[1rem]">
          <div className="flex flex-col w-full text-start gap-[0.125rem] ">
            <h1 className="text-[1.8rem]">Bienvenido!</h1>
            <p className="text-[1.rem]">
              Inicia sesión para gestionar tus desarrollos.
            </p>
          </div>
          {Object.keys(errors).length > 0 && (
            <div className="w-full px-4 py-2 bg-red-100 border border-red-400 text-red-700 rounded">
              {errors.email && (
                <span className="text-red-500">El email es requerido, </span>
              )}
              {errors.password && (
                <span className="text-red-500">La contraseña es requerida</span>
              )}
            </div>
          )}
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col w-full gap-[1.125rem] items-center"
          >
            <div className="flex flex-col w-full gap-[0.75rem] ">
              <CustomInput
                bg="bg-transparent"
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                border="border-black"
                {...register("email", { required: true })}
              />
              <div className="flex items-center justify-between w-full">
                <CustomInput
                  bg="bg-transparent"
                  type={ showPassword ? "text" : "password" }
                  id="password"
                  name="password"
                  placeholder="Contraseña"
                  border="border-black"
                  {...register("password", { required: true })}
                />
                <img onClick={() => setShowPassword(value => !value)} src={eyeIcon} className="-ml-8 pr-2 hover:scale-105 cursor-pointer"/>
              </div>
              <div className="flex items-center justify-between">
                <div className="control-group">
                  <label className="control control-checkbox flex items-center">
                    <input type="checkbox" />
                    <div className="control_indicator"></div>
                    <span className="ml-2 mt-[0.063rem] text-[1rem] ">
                      Recordarme
                    </span>
                  </label>
                </div>
                <span className="font-bold text-[0.75rem] underline hover:text-[#4C63ED] transition-all duration-300 cursor-pointer">
                  Olvidaste tu contraseña?
                </span>
              </div>
            </div>
            <button disabled={loading} className="flex w-full h-12 justify-center items-center px-[1.5rem] py-3 bg-[#282827] rounded-[8px]">
              {loading ?
                <Miniloader/>
                :
                <span className="text-white">Inicia Sesión</span>
              }
            </button>
            <div className="flex gap-[10px] ">
              <span className="text-[14px] ">Todavía no estás registrado?</span>
              <span
                onClick={handleRegisterClick}
                className="cursor-pointer text-[14px] text-[#4C63ED] font-medium underline"
              >
                Regístrate aquí.
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export { Login };